export default __webpack_public_path__ + "static/media/bg-principal.8a3d4ece.png";